module.exports = __webpack_public_path__ + "static/media/optionViewDark.7b4f53ad.svg";